export const bioLinks = [
  {
    id: 'idoat-canada',
    label: 'Order I Died On a Tuesday in Canada',
    url: 'https://www.penguinrandomhouse.ca/books/735470/i-died-on-a-tuesday-by-jane-corry/9780385697934',
    active: true,
  },
  {
    id: 'idoat-usa',
    label: 'Order I Died On a Tuesday in the US',
    url: 'https://www.penguinrandomhouse.com/books/735470/i-died-on-a-tuesday-by-jane-corry/',
    active: true,
  },
  {
    id: 'idoat-amazon',
    label: 'I Died On a Tuesday – Order on Amazon',
    url: 'https://www.amazon.co.uk/Died-Tuesday-gripping-thriller-bestselling-ebook/dp/B0CNT62W14',
    active: true,
  },
  {
    id: 'idoat-waterstones',
    label: 'I Died On a Tuesday – Order at Waterstones',
    url: 'https://www.waterstones.com/book/i-died-on-a-tuesday/jane-corry/9780241996126',
    active: true,
  },
  {
    id: 'apple-audio',
    label: 'Audiobook deals with @Applebooks',
    url: 'https://apple.co/4c7aMxH',
    active: true,
  },
  {
    id: 'domestika',
    label: 'Domestika – Creative Writing Course',
    url: 'https://www.domestika.org/en/courses/5207-creative-writing-techniques-for-short-stories/janecorryauthor',
    active: true,
  },
  {
    id: 'charlie-lovett',
    label: 'Charlie Lovett Podcast Episode with Jane Corry',
    url: 'https://charlielovett42.podbean.com/e/jane-corry-1152024-inside-the-writers-studio-episode-127/',
    active: true,
  },
];
